const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAllowedIpsApi = async (page = 1, perPage = 15, query = '') => {
    const token = localStorage.getItem('token');
    let url = `${API_BASE_URL}/admin/user/allowed-ips?page=${page}&per_page=${perPage}`;
    if (query) {
        url += `&query=${encodeURIComponent(query)}`;
    }

    try {
        const response = await fetch(
            url, 
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || 'Ошибка при получении списка разрешенных IP');
        }

        const data = await response.json();
        console.log('Allowed IPs Data:', data);
        return data;
    } catch (error) {
        console.error('Ошибка при получении списка разрешенных IP:', error);
        throw error;
    }
};